<form [formGroup]="inputForm" class="container">
    <mat-form-field appearance="outline">
        <mat-label>{{ profile.NotesTitle }}</mat-label>
        <textarea
        matInput
        rows="10"
        formControlName="TextArea"></textarea>
    </mat-form-field>
    <mat-radio-group formControlName="Selected" class="radiogroup" (change)="onChange($event)">
        <mat-radio-button class="radiobutton" *ngFor="let n of profile.DropdownEntries" [value]="n.value">
            {{ n.text }}
        </mat-radio-button>
    </mat-radio-group>
</form>